import { Mail, Plus, Upload } from "lucide-react";
import { useT } from "../i18n";

const inputCls = "w-full min-h-[44px] rounded-xl border border-[#0D4045]/15 bg-white px-3.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D4045]/30";

export default function AdminProsToolbar({ inviteEmail, setInviteEmail, onInvite, onImport, onAdd }) {
  const { t } = useT();
  return (
    <div className="flex flex-wrap items-center gap-3">
      <button data-testid="admin-add-pro-btn" onClick={onAdd}
        className="flex items-center gap-2 bg-[#0D4045] text-[#FDFBF7] text-sm font-semibold px-5 py-3 rounded-full hover:bg-[#0a3237] transition-colors duration-200">
        <Plus size={16} /> {t("admin.add")}
      </button>
      <form onSubmit={onInvite} className="flex gap-2 flex-1 min-w-[260px] max-w-md">
        <input data-testid="admin-invite-email" type="email" required value={inviteEmail}
          onChange={(e) => setInviteEmail(e.target.value)} placeholder={t("admin.invite.placeholder")}
          className={inputCls + " flex-1"} />
        <button type="submit" data-testid="admin-invite-btn"
          className="flex items-center gap-2 bg-[#E8F3F1] text-[#0D4045] text-sm font-semibold px-5 py-3 rounded-full hover:bg-[#d7eae6] transition-colors duration-200">
          <Mail size={15} /> {t("admin.invite")}
        </button>
      </form>
      <label data-testid="admin-import-label" title="name,specialty,commune,phone,email,note,languages,status"
        className="flex items-center gap-2 bg-white border border-[#0D4045]/15 text-[#0D4045] text-sm font-semibold px-5 py-3 rounded-full hover:bg-[#E8F3F1] transition-colors duration-200 cursor-pointer">
        <Upload size={15} /> {t("admin.import")}
        <input type="file" accept=".csv" data-testid="admin-import-input" className="hidden" onChange={onImport} />
      </label>
    </div>
  );
}
